import {
  AB_GROUP_CONTROL,
  AB_GROUP_NONE,
  FIM_AB_COOKIE_NAME,
  FIM_AB_HEADER_NAME,
} from '~/constants/experiments'

type Options = Parameters<typeof useShopConfiguration>[0]

export const useExperiments = (options?: Options, key = 'useExperiments') => {
  // check cookie on csr
  const cookie = useCookie(FIM_AB_COOKIE_NAME)
  // check header on ssr
  const header = useRequestHeader(FIM_AB_HEADER_NAME)

  const customDataPromise = useShopConfiguration({
    options: {
      ...options,

      transform: (data) => {
        return data.customData.abTestingConfig.experiments
      },
      getCachedData(key, nuxtApp) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    },
    key,
  })

  const { data, status, error, fetch } = customDataPromise

  const activeExperiment = computed(() => {
    const value = import.meta.server ? header : cookie.value

    // If there's no cookie or header, return undefined
    if (!value) {
      return undefined
    }

    const [name, variant] = value.split(':')

    // If the experiment is not found, return undefined & delete cookie
    if (!data.value?.[name]) {
      cookie.value = null
      return undefined
    }

    // if we're out of scope or in the control variant there's nothing to do
    if ([AB_GROUP_CONTROL, AB_GROUP_NONE].includes(variant)) {
      return undefined
    }

    return name
  })

  return extendPromise(
    customDataPromise.then(() => ({})),
    {
      data,
      status,
      error,
      fetch,
      activeExperiment,
    },
  )
}
